import { cn } from "cn";
import { MicOff } from "lucide-react";
import type * as React from "react";

export function SilenceNotice({
  message,
  className,
}: {
  message: string;
  className?: string;
}): React.JSX.Element {
  return (
    <p
      role="status"
      className={cn(
        "flex items-center gap-1.5 font-v3 text-[13px] text-v3-text-2",
        className,
      )}
    >
      <MicOff aria-hidden className="h-4 w-4 shrink-0" />
      {message}
    </p>
  );
}
